import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import { GenericCancelButton } from '@commons/Buttons';

export const GeneratePublicApiFormActionButtons = ({
  isValid,
  onClose,
  isSubmitting,
  handleSubmit,
  onGenerateSubmit,
}) => (
  <>
    <GenericCancelButton handleClick={onClose} minWidth={220} />
    <Button
      buttonCustomStyle={{ justifyContent: 'center' }}
      color={'inpulse-default'}
      handleClick={handleSubmit(onGenerateSubmit)}
      icon={'/images/inpulse/check-white-small.svg'}
      isDisabled={!isValid || isSubmitting}
      label={i18next.t('GENERAL.GENERATE')}
      minWidth={220}
    />
  </>
);
